var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9082 9.05202C4.71868 9.0525 4.53581 8.981 4.39697 8.85201L0.914055 5.60005C0.841828 5.53282 0.783667 5.45196 0.742668 5.3622C0.70167 5.27244 0.67857 5.17554 0.675041 5.07692C0.671513 4.9783 0.687438 4.87995 0.721916 4.78749C0.756395 4.69503 0.808732 4.61027 0.875969 4.53804C0.943206 4.46581 1.02425 4.40753 1.11401 4.36653C1.20376 4.32553 1.30055 4.30262 1.39916 4.29909C1.49778 4.29556 1.59625 4.31148 1.68871 4.34596C1.78117 4.38044 1.86575 4.43278 1.93798 4.50002L4.8662 7.235L10.52 1.06404C10.5842 0.983399 10.6643 0.916846 10.7554 0.868547C10.8464 0.820247 10.9465 0.791199 11.0493 0.78328C11.1521 0.775362 11.2554 0.788746 11.3528 0.822526C11.4502 0.856306 11.5394 0.909773 11.6152 0.979631C11.691 1.04949 11.7516 1.13422 11.7932 1.22853C11.8348 1.32284 11.8565 1.42472 11.8569 1.52779C11.8574 1.63085 11.8366 1.73292 11.7959 1.82759C11.7551 1.92226 11.6953 2.0075 11.6201 2.07802L5.45605 8.80702C5.38942 8.8802 5.30881 8.93929 5.21899 8.98085C5.12917 9.02241 5.03201 9.04561 4.9331 9.04903L4.9082 9.05202Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCheck);
export default __webpack_public_path__ + "static/media/disabledCheck.dfac195303103930ff5be6bebb9b1e6c.svg";
export { ForwardRef as ReactComponent };